import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { Col, Row, Card, Table } from '@themesberg/react-bootstrap'
import { getList } from '../../../../controller/api/ticket'
import { useCookies } from 'react-cookie'
import { TableRow } from '../component/TableRow'
import { calculatePage } from '../../../../helper/helper'
import Pagination from '../../../../components/Pagination'
import { Context } from '../Ticket'
import ImagePreview from '../sub-screen/image-preview/ImagePreview'

const _Table = () => {

  const { state } = useContext(Context);

  const [cookies] = useCookies(['lottmekong'])

  const [data, setData] = useState({})

  const [isCartGroup, setIsCartGroup] = useState(false)

  const [page, setPage] = useState(0)

  const [modalImageShow, setModalImageShow] = useState(false)
  
  const selectedImageRef = useRef('')
  
  const previewTitleRef = useRef('')

  const getAllFunc = useCallback(async () => {
    const response = await getList(cookies.lottmekong, {
      ticketId: state.ticketId,
      cartId: state.cartId,
    }, page)

    if (response) {
      const res = {
        list: response.data,
        total: response.total,
        totalPage: calculatePage(response.total)
      }
      setData(res || {})
    }
  }, [cookies.lottmekong, state.ticketId, state.cartId, page])

  const showImagePreview = (title, image) => {
    previewTitleRef.current = title

    selectedImageRef.current = image

    setModalImageShow(true)
  }

  useEffect(() => {
    if (state.cartId !== '' || state.ticketId !== '') {
      getAllFunc()
    }
  }, [getAllFunc, state.cartId, state.ticketId])

  useEffect(() => {
    if (data.list) {
      setIsCartGroup(data.list.some(it => it.cartGroupId !== null))
    }
  }, [data.list])

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Table responsive className="align-items-center table-bordered table-hover">
          <thead className='text-center'>
            <tr>
              <th scope="col">Thao tác</th>
              {!isCartGroup && <th scope="col">Mã đơn</th>}
              <th scope="col">Mã vé</th>
              <th scope="col">{!isCartGroup ? 'Người chơi' : 'Nhóm mua chung'}</th>
              <th scope="col">Thông tin vé</th>
              <th scope="col">Giá trị</th>
              <th scope="col">Trạng thái</th>
              <th scope="col">Ngày mua</th>
              <th scope="col">Ngày thanh toán</th>
              <th scope="col">Ngày hủy</th>
              <th scope="col">Ngày in</th>
              <th scope="col">USB</th>
            </tr>
          </thead>
          <tbody>
            {data.list && data.list.map((pv, index) => <TableRow rIndex={index} key={`table-keys-lottmekong-${pv.id}`} {...pv} />)}
          </tbody>
        </Table>
        <Card.Footer className='flex-row'>
          <Row className="align-items-center">
            <Col>
              <Pagination
                totalPage={data.totalPage || 0}
                currentPage={page || 0}
                onPageChange={(i) => {
                  setPage(i)
                }}
              />
            </Col>
          </Row>
        </Card.Footer>
      </Card>
      <ImagePreview
        show={modalImageShow}
        title={previewTitleRef.current}
        image={selectedImageRef.current}
        onHide={() => setModalImageShow(false)}
      />
    </>
  );
};

export default React.memo(_Table)